module.exports = __webpack_public_path__ + "img/clube8.6567ea96.jpeg";